import type { InviteByEmailData, ShareAuthCheckData, ShareLinkResponse } from '../types';

export interface ShareService {
  getShareId(data: ShareAuthCheckData): Promise<ShareLinkResponse>;
  inviteByEmail(data: InviteByEmailData): Promise<void>;
}

export const ShareService = Symbol('ShareService');
